<template>
  <form @submit.prevent="submit">
    <Field
      type="select"
      :options="companies"
      label="Company name"
      @input="$v.resource.companyId.$touch()"
      v-model="resource.companyId"
      :error="companyIdError"
    />

    <Field
      type="select"
      :options="websites"
      label="Website"
      @input="$v.resource.siteId.$touch()"
      v-model="resource.siteId"
      :error="siteIdError"
    />

    <Field
      type="select"
      :options="pages"
      label="Page"
      @input="$v.resource.pageId.$touch()"
      v-model="resource.pageId"
      :error="pageIdError"
    />

    <Field
      type="select"
      :options="galleries"
      label="Gallery"
      @input="$v.resource.galleryId.$touch()"
      v-model="resource.galleryId"
      :error="galleryIdError"
    />

    <Field
      type="textarea"
      disableEditor
      label="Image URLs"
      helpText="Upload images to <strong>PostImage</strong> and paste the direct URLs in here"
      @input="$v.resource.imageUrls.$touch()"
      v-model="resource.imageUrls"
      :error="imageUrlsError"
    />

    <div class="btn-save">
      <btn primary :disabled="$v.$invalid">Start Job</btn>
    </div>
  </form>
</template>

<script>
import form from '@/mixins/form'
import siteTemplates from '@/mixins/siteTemplates'

import Btn from '@/components/Btn'

import {errorMessages} from '@/lib/error_messages'
import {required} from 'vuelidate/lib/validators'

export default {
  name: 'CreateWebsiteForm',

  mixins: [form, siteTemplates],

  props: {
    companies: {
      type: Array,
      required: true
    },

    websites: {
      type: Array,
      required: true
    },

    pages: {
      type: Array,
      required: true
    },

    galleries: {
      type: Array,
      required: true
    }
  },

  components: {
    Btn
  },

  computed: {
    ...errorMessages([
      'companyId',
      'siteId',
      'pageId',
      'galleryId',
      'imageUrls'
    ])
  },

  validations: {
    resource: {
      companyId: {required},
      siteId: {required},
      pageId: {required},
      galleryId: {required},
      imageUrls: {required}
    }
  }
}
</script>
